export const SET_INFO = 'SET_INFO';
export const SET_EST_PRICE = 'SET_EST_PRICE';
export const SET_DIFF_PRICE = 'SET_DIFF_PRICE';

